import Affair from '@/models/search/filter/Affair';
import Session from '@/models/search/filter/Session';
import Category from '@/models/search/filter/Category';
import Group from '@/models/search/filter/Group';
import Column from '@/models/search/filter/Column';
import Field from '@/models/search/filter/Field';

export default class Filter {
  public affairs: Affair[] = [];
  public sessions: Session[] = [];
  public categories: Category[] = [];
  public groups: Group[] = [];
  public protocols: string[] = [];
  public columns: Column[] = [];
  public fields: Field[] = [];
}
